var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-phone-number-field-wrapper",attrs:{"data-deliver-part":"deliver-code"}},[_c('ot-phone-number-field',{model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }